// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .gallery-component.list-view {
  padding: 0;
}
:host .gallery-component.list-view ion-col {
  height: 33vw;
  padding: 0;
}
:host .gallery-component.list-view ion-col img {
  height: 100%;
  width: 100%;
  object-fit: cover;
}
:host .gallery-component.list-view .is-video .icon-play {
  background-color: white;
  border-radius: 50%;
  height: 25px;
  width: 25px;
  top: calc(50% - 13px);
  padding: 5px 3px 5px 7px;
  left: calc(50% - 17px);
  position: absolute;
  box-shadow: 0px 0px 10px -2px var(--ion-color-dark);
  color: var(--ion-color-dark);
}
:host iframe {
  border: none;
  display: block;
}

.links-container-grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.links-container-grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.links-container-grid-cols-2, .links-container-grid-cols-3 {
  display: grid;
  padding: 10px;
}
.links-container-grid-cols-2 .child, .links-container-grid-cols-3 .child {
  padding: 25px;
}
.links-container-grid-cols-2 .child i, .links-container-grid-cols-3 .child i {
  margin-right: 5px;
}
.links-container-grid-cols-2 .child ion-label, .links-container-grid-cols-3 .child ion-label {
  font-weight: bold;
  font-size: 0.7em;
}

::ng-deep image-loader.grid-image img {
  aspect-ratio: 1/1;
  object-fit: cover;
  border-radius: 8px;
}

:host-context(.plt-desktop) .gallery-component.list-view ion-col {
  padding-top: 33%;
  position: relative;
  height: 0px;
}
:host-context(.plt-desktop) .gallery-component.list-view ion-col img {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  object-fit: cover;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/app/components/item-searcher/item-searcher.scss"],"names":[],"mappings":"AAEI;EACE,UAAA;AADN;AAEM;EACE,YAAA;EACA,UAAA;AAAR;AACQ;EACE,YAAA;EACA,WAAA;EACA,iBAAA;AACV;AAIQ;EACE,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,qBAAA;EACA,wBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mDAAA;EACA,4BAAA;AAFV;AAOE;EACE,YAAA;EACA,cAAA;AALJ;;AASA;EACE,gDAAA;AANF;;AAQA;EACE,gDAAA;AALF;;AAQA;EACE,aAAA;EACA,aAAA;AALF;AAME;EACI,aAAA;AAJN;AAKM;EACE,iBAAA;AAHR;AAKM;EACE,iBAAA;EACA,gBAAA;AAHR;;AAUE;EACE,iBAAA;EACA,iBAAA;EACA,kBAAA;AAPJ;;AAcM;EACE,gBAAA;EACA,kBAAA;EACA,WAAA;AAXR;AAaQ;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,iBAAA;EACA,eAAA;AAXV","sourcesContent":[":host {\n  .gallery-component {\n    &.list-view {\n      padding: 0;\n      ion-col {\n        height: 33vw;\n        padding: 0;\n        img {\n          height: 100%;\n          width: 100%;\n          object-fit: cover;\n        }\n      }\n\n      .is-video {\n        .icon-play {\n          background-color: white;\n          border-radius: 50%;\n          height: 25px;\n          width: 25px;\n          top: calc(50% - 13px);\n          padding: 5px 3px 5px 7px;\n          left: calc(50% - 17px);\n          position: absolute;\n          box-shadow: 0px 0px 10px -2px var(--ion-color-dark);\n          color: var(--ion-color-dark);\n        }\n      }\n    }\n  }\n  iframe {\n    border: none;\n    display: block;\n  }\n}\n\n.links-container-grid-cols-3 {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n.links-container-grid-cols-2 {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n.links-container-grid-cols-2, .links-container-grid-cols-3 {\n  display: grid;\n  padding: 10px;\n  .child{\n      padding: 25px;\n      i{\n        margin-right: 5px;\n      }\n      ion-label{\n        font-weight: bold;\n        font-size: 0.7em;\n      }\n      \n  }\n}\n\n::ng-deep image-loader.grid-image{\n  img{\n    aspect-ratio: 1 / 1;\n    object-fit: cover;\n    border-radius: 8px;\n  }\n}\n\n:host-context(.plt-desktop) {\n  .gallery-component {\n    &.list-view {\n      ion-col {\n        padding-top: 33%;\n        position: relative;\n        height: 0px;\n\n        img {\n          position: absolute;\n          width: 100%;\n          height: 100%;\n          top: 0;\n          left: 0;\n          object-fit: cover;\n          cursor: pointer;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
